export const buttonStyle = 'border border-slate-100 rounded-md p-5 bg-pink-600 even:bg-pink-700 text-white font-bold shadow-lg shadow-pink-500/40 h-28 text-xl hover:bg-pink-700 even:hover:bg-pink-800';
export const screenStyle = 'max-w-xs sm:max-w-md md:max-w-2xl lg:max-w-4xl xl:max-w-6xl mx-auto';
